<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Mountings,Duraframes"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Any DuraFrame can be surface-mounted, vertically mounted on or between posts, or at a low-profile
          angle on posts. All DuraFrames have a full metal backing and are designed to frame a 1/8" thick sign
          panel. Each DuraFrame includes standard wall-mounts. Posts, sleeves for wood posts, and rail mount
          brackets are also available.</div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img duraframes-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/duraframes/low-profile-frame-with-wood-post-mounts.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img duraframes-85-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/duraframes/duraframe-with-rail-mount-bracket.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img duraframes-77-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/duraframes/duraframe-with-low-profile-pedestal-post.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <div class="img duraframes-77-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/duraframes/duraframe-with-flush-mount-post.jpg') + ')'}"></div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Duraframes'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Duraframes.vue